import { BaseDynamicZoneModel } from "@models/dynamic-zones";
import { ImageDataLike } from "gatsby-plugin-image";

export enum ImageWrapperVariants {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
}

export enum ImagePosition {
  RIGHT = "right",
  LEFT = "left",
}

export interface ImageWrapperDynamicZoneModel extends BaseDynamicZoneModel {
  learnMoreLink: string;
  imageWrapper: { localFile: ImageDataLike | null };
  variant: ImageWrapperVariants;
  imgPosition: ImagePosition;
  divColor: string;
  menuDescription?: string;
}
